import { createSlice } from "@reduxjs/toolkit";
import {
  getAllDoctorServices,
  getDoctorServicesAndFees,
  getFeesListing,
} from "../../../api/fee-management-api/Fee.service";
import { getDoctorsName } from "../../../api/doctor-api/Api.service";
// import { feeData } from "../Data";

export interface ServiceAndFeesArray {
  encryptedServicesIds: string[];
  fees: number | null;
}

export interface FeeStateData {
  id?: string | number;
  encryptedDoctorId: string;
  encryptedClinicId: string;
  publicHolidayFee?: number;
  afterHoursFee?: number;
  weekendFee?: number;
  servicesAndFees?: ServiceAndFeesArray[];
  encryptedDoctorClinicId?: string;
}

interface AllServicesStruct {
  encryptedServiceId: string;
  serviceCode: string;
  serviceName: string;
}

interface DoctorsName {
  id: string;
  name: string;
}

interface FeeState {
  fees: FeeStateData[];
  editeFeeData: FeeStateData | {};
  totalRecords: number;
  allServices: AllServicesStruct[] | [];
  dropDownDoctors: DoctorsName[];
  feeLoading: boolean;
  feeStatusLoading: boolean;
  feeAddPageLoading: boolean;
  feeEditPageLoading: boolean;
}

const initialState: FeeState = {
  fees: [],
  editeFeeData: {},
  totalRecords: 0,
  allServices: [],
  dropDownDoctors: [],
  feeLoading: false,
  feeStatusLoading: false,
  feeAddPageLoading: false,
  feeEditPageLoading: false,
};

const FeeSlice = createSlice({
  name: "fee",
  initialState,
  reducers: {
    feeTableIsLoading: (state, { payload }) => {
      state.feeLoading = payload;
    },
    feeStatusIsLoading: (state, { payload }) => {
      state.feeStatusLoading = payload;
    },
    feeAddIsLoading: (state, { payload }) => {
      state.feeAddPageLoading = payload;
    },
    feeEditIsLoading: (state, { payload }) => {
      state.feeEditPageLoading = payload;
    },
    feeStatusToggle: (state, { payload }) => {
      state.fees = state.fees.map((e: any) => {
        if (e.encryptedDoctorClinicId === payload) {
          if (e.serviceFeesStatus === 0) {
            return { ...e, serviceFeesStatus: 1 };
          } else {
            return { ...e, serviceFeesStatus: 0 };
          }
        } else {
          return e;
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFeesListing.fulfilled, (state, { payload }: any) => {
      state.totalRecords = payload?.result.totalRecords;
      state.fees = payload.result.data.map((e: any, i: number) => ({
        id: i,
        ...e,
      }));
    });
    builder.addCase(
      getDoctorServicesAndFees.fulfilled,
      (state, { payload }: any) => {
        state.editeFeeData = payload.result;
      }
    );
    builder.addCase(
      getAllDoctorServices.fulfilled,
      (state, { payload }: any) => {
        state.allServices = payload.result;
      }
    );
    builder.addCase(getDoctorsName.fulfilled, (state, { payload }: any) => {
      state.dropDownDoctors = payload.result;
    });
  },
});
export const FeeSliceReducer = FeeSlice.reducer;
export const {
  feeTableIsLoading,
  feeStatusIsLoading,
  feeStatusToggle,
  feeEditIsLoading,
  feeAddIsLoading,
} = FeeSlice.actions;
